module.exports = __webpack_public_path__ + "static/media/simple-icon.4050d695.svg";